
/**
 * 
 * @param title string
 * @param level string
 * @param argueType string
 * @returns replace spaces in the title with dashes for a URL-friendly format
 */
export function generateSlug( title, level, argueType,time ) {
    const formattedTitle = title.replace(/\s+/g, '-').toLowerCase();
    const formattedLevel = level.toLowerCase();
    const formattedArgueType = argueType.toLowerCase();
    const numberTime = Number(time)
  
    const slugId = `${formattedTitle}-${formattedLevel}-${formattedArgueType}-${numberTime}min`;
    return slugId;
}

  